module.exports = __webpack_public_path__ + "img/pic_usa_06.11f6ae9a.jpg";